var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('h2',[_vm._v("Выручка")]),_vm._v(" "),_c('h1',{staticClass:"revenue_value"},[_vm._v("\n    "+_vm._s(_vm.formatNumber(_vm.data))+" "+_vm._s(_vm.$store.state.currency)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fc438d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/home/revenueChart2.vue
// module id = null
// module chunks = 